module.exports = __webpack_public_path__ + "media/images/logo/logo_chariloto_3-d1b8385b3ce2fa3d7cb05ffbec5b32d2.svg";